import React from "react";
import "./css/post-3209.css";
const Contact = () => {
  return (
    <div
      data-elementor-type="wp-page"
      data-elementor-id={3209}
      className="elementor elementor-3209"
    >
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-e8960af elementor-section-height-min-height elementor-section-items-stretch elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
        data-id="e8960af"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ab7d648 cmsmasters-bg-hide-none cmsmasters-bg-hide-none"
            data-id="ab7d648"
            data-element_type="column"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-42d7f0c elementor-section-full_width elementor-section-height-min-height elementor-section-height-default cmsmasters-block-default"
                data-id="42d7f0c"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4eabf4e"
                    data-id="4eabf4e"
                    data-element_type="column"
                    data-settings='{"background_background":"classic"}'
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-82f2919 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="82f2919"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-heading-title elementor-size-default">
                            Contact us
                          </div>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-c490185 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="c490185"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Customer Service and Support
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-08a1642 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="08a1642"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            Contact us for answers to all of your
                            questions.
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-29e5dc3 elementor-hidden-mobile"
                    data-id="29e5dc3"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-4bc8ea5 elementor-widget__width-initial cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                        data-id="4bc8ea5"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <img
                            decoding="async"
                            width={174}
                            height={174}
                            src="/imges/contact/shape-1.svg"
                            className="attachment-large size-large wp-image-98"
                            alt=""
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-ec16699 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="ec16699"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-79addfb"
            data-id="79addfb"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-552b7aa cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                data-id="552b7aa"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    ​You can reach us by
                  </h2>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-a73b4e5 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="a73b4e5"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-823c725"
            data-id="823c725"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-c80ce79 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="c80ce79"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-wide">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-2b00b2e"
                    data-id="2b00b2e"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-2abd3e9 elementor-view-default elementor-position-top elementor-mobile-position-top cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon-box"
                        data-id="2abd3e9"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-icon-box-wrapper">
                            <div className="elementor-icon-box-icon" style={{textAlign:"center"}}>
                              <span className="elementor-icon">
                                <i
                                  aria-hidden="true"
                                  className="cmsmsdemo-icon- cmsms-demo-icon-wallet"
                                />{" "}
                              </span>
                            </div>
                            <div className="elementor-icon-box-content">
                              <h4 className="elementor-icon-box-title" style={{textAlign:"center"}}>
                                <span>Email </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-9e720eb cmsmasters-widget-layout-column cmsmasters-widget-align-column-center cmsmasters-widget-direction-default cmsmasters-value-position-bottom cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="9e720eb"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    Oman{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value active-link-item cmsmasters-widget-icon-list-item-value">
                                <a href="#">info@buroojgroup.com</a>
                              </span>{" "}
                            </li>
                            {/* <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Los Angeles Office{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value active-link-item cmsmasters-widget-icon-list-item-value">
                                <a href="#">losangeles@ex.com</a>
                              </span>{" "}
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Boston Office{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value active-link-item cmsmasters-widget-icon-list-item-value">
                                <a href="#">boston@example.com</a>
                              </span>{" "}
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-6319c5f"
            data-id="6319c5f"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-b3743b2 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="b3743b2"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-wide">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-5893a5a"
                    data-id="5893a5a"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-355ae21 elementor-view-default elementor-position-top elementor-mobile-position-top cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon-box"
                        data-id="355ae21"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-icon-box-wrapper">
                            <div className="elementor-icon-box-icon" style={{textAlign:"center"}}>
                              <span className="elementor-icon">
                                <i
                                  aria-hidden="true"
                                  className="cmsmsdemo-icon- cmsms-demo-icon-contact"
                                />{" "}
                              </span>
                            </div>
                            <div className="elementor-icon-box-content">
                              <h4 className="elementor-icon-box-title" style={{textAlign:"center"}}>
                                <span>Phone </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-6aa78c7 cmsmasters-widget-layout-column cmsmasters-widget-align-column-center cmsmasters-widget-direction-default cmsmasters-value-position-bottom cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="6aa78c7"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    Customer Care Center{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value active-link-item cmsmasters-widget-icon-list-item-value">
                                <a href="tel:+968 79281277">+968 79281277</a>
                              </span>{" "}
                            </li>
                            {/* <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Monday through Friday{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value cmsmasters-widget-icon-list-item-value">
                                7:30 a.m. to 12:00 a.m. EST
                              </span>{" "}
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Saturday and Sunday{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value cmsmasters-widget-icon-list-item-value">
                                9:00 a.m. to 6:00 p.m. EST
                              </span>{" "}
                            </li> */}
                          </ul>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-6319c5f"
            data-id="6319c5f"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-b3743b2 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="b3743b2"
                data-element_type="section"
                style={{padding:"30px 20px 5px 20px"}}
              >
                <div className="elementor-container elementor-column-gap-wide">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-5893a5a"
                    data-id="5893a5a"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-355ae21 elementor-view-default elementor-position-top elementor-mobile-position-top cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon-box"
                        data-id="355ae21"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-icon-box-wrapper">
                            <div className="elementor-icon-box-icon" style={{textAlign:"center"}}>
                              <span className="elementor-icon">
                              <i
                                  aria-hidden="true"
                                  className="cmsmsdemo-icon- cmsms-demo-icon-letter"
                                />{" "}
                              </span>
                            </div>
                            <div className="elementor-icon-box-content">
                              <h4 className="elementor-icon-box-title" style={{textAlign:"center"}}>
                                <span>Mail </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-6aa78c7 cmsmasters-widget-layout-column cmsmasters-widget-align-column-center cmsmasters-widget-direction-default cmsmasters-value-position-bottom cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="6aa78c7"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    Customer Care Center{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value active-link-item cmsmasters-widget-icon-list-item-value">
                                <a href="tel:1-123-456-7890"> Burooj P.O.Box 766, Post Code 115 Muscat, Oman</a>
                              </span>{" "}
                            </li>
                            {/* <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Monday through Friday{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value cmsmasters-widget-icon-list-item-value">
                                7:30 a.m. to 12:00 a.m. EST
                              </span>{" "}
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    Saturday and Sunday{" "}
                                  </span>
                                </span>
                              </span>
                              <span className="cmsmasters-widget-icon-list-item-value cmsmasters-widget-icon-list-item-value">
                                9:00 a.m. to 6:00 p.m. EST
                              </span>{" "}
                            </li> */}
                          </ul>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
      
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-f8d238c elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="f8d238c"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-009fa25"
            data-id="009fa25"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-a5a499e elementor-section-full_width elementor-section-height-min-height elementor-section-height-default cmsmasters-block-default"
                data-id="a5a499e"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d5700ab"
                    data-id="d5700ab"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-3ae32e9 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                        data-id="3ae32e9"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <img
                            fetchpriority="high"
                            decoding="async"
                            width={1024}
                            height={870}
                            src="/imges/contact/contacts-2-1-1024x870.jpg"
                            className="attachment-large size-large wp-image-2794 cmsmasters_img cmsmasters-lazyload lazyloaded"
                            alt=""
                            data-sizes="(max-width: 1024px) 100vw, 1024px"
                            // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-1024x870.jpg"
                            // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-1024x870.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-300x255.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-768x653.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-353x300.jpg 353w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-600x510.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-30x26.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-12x10.jpg 12w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1.jpg 1040w"
                            // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-1024x870.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-300x255.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-768x653.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-353x300.jpg 353w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-600x510.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-30x26.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1-12x10.jpg 12w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/contacts-2-1.jpg 1040w"
                            sizes="(max-width: 1024px) 100vw, 1024px"
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8d2a3dc"
                    data-id="8d2a3dc"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-e2a7492 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="e2a7492"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h6 className="elementor-heading-title elementor-size-default">
                            Add Your Heading Text Here
                          </h6>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-6d72bf7 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="6d72bf7"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Send us an inquiry
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-9fd6a33 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="9fd6a33"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            A question? An issue? Drop us a line and we'll see
                            how we can help.
                          </p>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-f368d62 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-forminator"
                        data-id="f368d62"
                        data-element_type="widget"
                        data-settings='{"form_list":"21"}'
                        data-widget_type="cmsmasters-forminator.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="elementor-widget-cmsmasters-contact-form__wrapper elementor-widget-cmsmasters-contact-form cmsmasters-default-color cmsmasters-default-font"
                            id="cmsmasters-widget-form-f368d62"
                          >
                            <div className="elementor-widget-cmsmasters-contact-form__inner">
                              <form
                                id="forminator-module-21"
                                className="forminator-ui forminator-custom-form forminator-custom-form-21 forminator-design--default  forminator_ajax"
                                method="post"
                                data-forminator-render={0}
                                data-form-id={21}
                                data-design="default"
                                data-grid="open"
                                // style={{}}
                                data-uid="67b699dbc4552"
                                noValidate="novalidate"
                              >
                                <div
                                  role="alert"
                                  aria-live="polite"
                                  className="forminator-response-message forminator-error"
                                  aria-hidden="true"
                                />
                                <div className="forminator-row">
                                  <div
                                    id="select-1"
                                    className="forminator-field-select forminator-col forminator-col-12 "
                                  >
                                    <div className="forminator-field">
                                      <label
                                        htmlFor="forminator-form-21__field--select-1_67b699dbc4552"
                                        id="forminator-form-21__field--select-1_67b699dbc4552-label"
                                        className="forminator-label"
                                      >
                                        Subject
                                      </label>
                                      <select
                                        id="forminator-form-21__field--select-1_67b699dbc4552"
                                        className="forminator-select--field forminator-select2 forminator-select2-multiple select2-hidden-accessible forminator-screen-reader-only"
                                        data-required
                                        name="select-1"
                                        data-default-value
                                        data-placeholder="Select option"
                                        data-search="false"
                                        data-search-placeholder="Select option"
                                        data-checkbox="false"
                                        data-allow-clear="false"
                                        aria-labelledby="forminator-form-21__field--select-1_67b699dbc4552-label"
                                        data-select2-id="select2-data-forminator-form-21__field--select-1_67b699dbc4552"
                                       
                                        aria-hidden="true"
                                      >
                                        <option
                                          value
                                          data-select2-id="select2-data-2-f13o"
                                        >
                                          Select option
                                        </option>
                                        <option
                                          value="Wealth-Management"
                                          data-calculation={0}
                                        >
                                         Burooj Trading
                                        </option>
                                        <option
                                          value="Checking-Accounts"
                                          data-calculation={0}
                                        >
                                         Burooj Investments
                                        </option>
                                        <option
                                          value="Credit-Cards"
                                          data-calculation={0}
                                        >
                                          Burooj Properties
                                        </option>
                                        <option
                                          value="Mortgages"
                                          data-calculation={0}
                                        >
                                          Burooj Services
                                        </option>
                              
                                      </select>
                                      <span
                                        className="select2 select2-container forminator-select"
                                        dir="ltr"
                                        data-select2-id="select2-data-1-cj48"
                                        style={{ width: "675.031px" }}
                                      >
                                        <span className="selection">
                                          <span
                                            className="select2-selection select2-selection--single"
                                            role="combobox"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                           
                                            aria-disabled="false"
                                            aria-labelledby="select2-forminator-form-21__field--select-1_67b699dbc4552-container"
                                            aria-controls="select2-forminator-form-21__field--select-1_67b699dbc4552-container"
                                          >
                                            <span
                                              className="select2-selection__rendered"
                                              id="select2-forminator-form-21__field--select-1_67b699dbc4552-container"
                                              role="textbox"
                                              aria-readonly="true"
                                              title="Select option"
                                            >
                                              <span className="select2-selection__placeholder">
                                                Select option
                                              </span>
                                            </span>
                                            <span
                                              className="select2-selection__arrow"
                                              role="presentation"
                                            >
                                              <span
                                                className="forminator-icon-chevron-down"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </span>
                                        </span>
                                        <span
                                          className="dropdown-wrapper"
                                          aria-hidden="true"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="forminator-row">
                                  <div
                                    id="name-1"
                                    className="forminator-field-name forminator-col forminator-col-6 "
                                  >
                                    <div className="forminator-field">
                                      <label
                                        htmlFor="forminator-field-name-1_67b699dbc4552"
                                        id="forminator-field-name-1_67b699dbc4552-label"
                                        className="forminator-label"
                                      >
                                        Your Name{" "}
                                        <span className="forminator-required">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        name="name-1"
                                        
                                        placeholder
                                        id="forminator-field-name-1_67b699dbc4552"
                                        className="forminator-input forminator-name--field"
                                        aria-required="true"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    id="email-1"
                                    className="forminator-field-email forminator-col forminator-col-6 "
                                  >
                                    <div className="forminator-field">
                                      <label
                                        htmlFor="forminator-field-email-1_67b699dbc4552"
                                        id="forminator-field-email-1_67b699dbc4552-label"
                                        className="forminator-label"
                                      >
                                        Your Email{" "}
                                        <span className="forminator-required">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="email"
                                        name="email-1"
                                        
                                        placeholder
                                        id="forminator-field-email-1_67b699dbc4552"
                                        className="forminator-input forminator-email--field"
                                        data-required="true"
                                        aria-required="true"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="forminator-row">
                                  <div
                                    id="textarea-1"
                                    className="forminator-field-textarea forminator-col forminator-col-12 "
                                  >
                                    <div className="forminator-field">
                                      <label
                                        htmlFor="forminator-field-textarea-1_67b699dbc4552"
                                        id="forminator-field-textarea-1_67b699dbc4552-label"
                                        className="forminator-label"
                                      >
                                        Your Message
                                      </label>
                                      <textarea
                                        name="textarea-1"
                                        placeholder
                                        id="forminator-field-textarea-1_67b699dbc4552"
                                        className="forminator-textarea"
                                        rows={6}
                                        style={{ minHeight: "120px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <input
                                  type="hidden"
                                  name="referer_url"
                                  
                                />
                                <div className="forminator-row forminator-row-last">
                                  <div className="forminator-col">
                                    <div className="forminator-field">
                                      <button className="forminator-button forminator-button-submit">
                                        Send Message
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <input
                                  type="hidden"
                                  id="forminator_nonce"
                                  name="forminator_nonce"
                                />
                                <input
                                  type="hidden"
                                  name="_wp_http_referer"
                                />
                                <input
                                  type="hidden"
                                  name="form_id"
                                
                                />
                                <input
                                  type="hidden"
                                  name="page_id"
                                
                                />
                                <input
                                  type="hidden"
                                  name="form_type"
                                
                                />
                                <input
                                  type="hidden"
                                  name="current_url"
                                  
                                />
                                <input
                                  type="hidden"
                                  name="render_id"
                                
                                />
                                <input
                                  type="hidden"
                                  name="action"
                                  
                                />
                              </form>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-c603924 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="c603924"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e0116a8"
            data-id="e0116a8"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-346e0ea elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="346e0ea"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-1430e1a"
                    data-id="1430e1a"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-8aaf436 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="8aaf436"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                           Looking for Us? Here’s How to Reach Us!
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-8f56612 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="8f56612"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        {/* <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            More than 55,000 ATMs worldwide
                          </p>{" "}
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-34f4f3c"
                    data-id="34f4f3c"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-122d7fe cmsmasters-button-align-right cmsmasters-button-mobile-align-center cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                        data-id="122d7fe"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-button__button-container">
                            <div className="elementor-widget-cmsmasters-button__button-container-inner">
                              <a
                                href="/"
                                className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                role="button"
                              >
                                <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                                  <span className="elementor-widget-cmsmasters-button__text">
                                    Search Now
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div
                className="elementor-element elementor-element-d5c01c2 elementor-hidden-mobile cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                data-id="d5c01c2"
                data-element_type="widget"
                data-widget_type="image.default"
              >
                <div className="elementor-widget-container">
                  <img
                    decoding="async"
                    width={1024}
                    height={608}
                    src="/imges/contact/google-map-placeholder-1024x608.webp"
                    className="attachment-large size-large wp-image-9915 cmsmasters_img cmsmasters-lazyload lazyloaded"
                    alt=""
                    data-sizes="(max-width: 1024px) 100vw, 1024px"
                    // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-1024x608.webp"
                    // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-1024x608.webp 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-300x178.webp 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-768x456.webp 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-505x300.webp 505w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-600x356.webp 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-30x18.webp 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-17x10.webp 17w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder.webp 1280w"
                    // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-1024x608.webp 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-300x178.webp 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-768x456.webp 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-505x300.webp 505w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-600x356.webp 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-30x18.webp 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder-17x10.webp 17w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2025/02/google-map-placeholder.webp 1280w"
                    sizes="(max-width: 1024px) 100vw, 1024px"
                  />{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
